<template lang="pug">
  app-modal(
    :titulo="titulo",
    @closeModal="closeModal()",
    :width="1000",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      el-tabs.tabs(
        type="border-card"
        @tab-click="handleClick",
        v-model="abaAtiva",
      )
        el-tab-pane(name='cadastro')
          span(slot="label" id="CADASTRO")
              | Cadastro &nbsp
          div
            tabs-visualizar-gleba(:idGleba='idGleba')
        el-tab-pane(name='processosVinculados')
          span(slot="label" id="PROCESSOSVINCULADOS")
              | Processos vinculados &nbsp

          div(v-if="possuiVinculoProcesso").exportar
            el-button(@click="getCsv") Exportar CSV
          div(v-else).exportar
            p A gleba não possui processos vinculados.
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import TabsVisualizarGleba from './TabsVisualizarGleba.vue'

export default {

  components: {
    AppModal,
    TabsVisualizarGleba
  },

  props: {
    idGleba: {
      required: true
    },
    titulo: {
      type: String,
      required: true
    }
  },
  async created () {
    this.possuiVinculoProcesso = await this.hasProcessoVinculado(this.idGleba)
  },
  data () {
    return {
      abaAtiva: 'cadastro',
      possuiVinculoProcesso: false
    }
  },
  methods: {
    ...mapActions({
      getCsvProcesso: 'gleba/getProcessoCsv',
      hasProcessoVinculado: 'gleba/hasProcessoVinculado'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    async handleClick (tab) {
      this.abaAtiva = tab.name
    },
    async getCsv () {
      await this.getCsvProcesso(this.idGleba)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tabs--border-card {
  box-shadow: none;
}
.exportar {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/gleba/ModalVisualizarGleba.vue